module.exports = __webpack_public_path__ + "static/img/user.82ce3c3.png";